export default __webpack_public_path__ + "static/media/gastronovas1.e5e497aa.jpg";